export const ContentInterfaceType = {
    VIDEO: 'Video',
    IMAGE: 'Image'
};



// WEBPACK FOOTER //
// ./common/language/content_component/content_interface_type.js